import PropTypes from "prop-types";

const ChartLegend = ({ items }) => {
  return (
    <div className="flex flex-wrap justify-center gap-4 mt-3">
      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-sm"
            style={{ backgroundColor: item.color }}
          ></div>
          <span className="text-xs font-medium text-gray-700">
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
};

ChartLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ChartLegend;
